/** Registry sync version — keep identical in UI registry file. */
export const PLATFORM_PERMISSION_REGISTRY_VERSION = 1;

export const PERMISSION_LEVELS = ['NO_ACCESS', 'READ_ONLY', 'EXECUTE'] as const;
export type PermissionLevel = (typeof PERMISSION_LEVELS)[number];

export const PERMISSION_LEVEL_NO_ACCESS: PermissionLevel = 'NO_ACCESS';
export const PERMISSION_LEVEL_READ_ONLY: PermissionLevel = 'READ_ONLY';
export const PERMISSION_LEVEL_EXECUTE: PermissionLevel = 'EXECUTE';

export type PermissionActionDef = {
  key: string;
  label: string;
  allowedLevels: PermissionLevel[];
};

export type PermissionModuleDef = {
  moduleKey: string;
  label: string;
  route?: string;
  parentKey?: string;
  kind: 'group' | 'module';
  accessOnly: boolean;
  actions: PermissionActionDef[];
};

export type RoleModulePermission = {
  moduleKey: string;
  access: boolean;
  actions: Record<string, PermissionLevel>;
};

export type EffectivePermissions = {
  modules: Record<string, { access: boolean; actions: Record<string, PermissionLevel> }>;
};

export const READ_LEVELS: PermissionLevel[] = [PERMISSION_LEVEL_NO_ACCESS, PERMISSION_LEVEL_READ_ONLY];
export const MUTATION_LEVELS: PermissionLevel[] = [
  PERMISSION_LEVEL_NO_ACCESS,
  PERMISSION_LEVEL_READ_ONLY,
  PERMISSION_LEVEL_EXECUTE,
];

export function readAction(key: string, label = 'Read / View'): PermissionActionDef {
  return { key, label, allowedLevels: [...READ_LEVELS] };
}

export function mutationAction(key: string, label: string): PermissionActionDef {
  return { key, label, allowedLevels: [...MUTATION_LEVELS] };
}
